import { useState } from "react";
import Notification from "../../model/notification";
import ProfileState from "../../model/Profile";

export function useNotification(category: string, type: string, time: number): [Notification, Function] {

    const [state, setState] = useState({ category: category, type: type, time: time });

    return [state,
        (person: ProfileState, category: string, type: string, time: number) => {
            setState({ category: category, type: type, time: time });
        },
    ];
}
